import { getParticipantName } from ".";
export function getParticipantData(event, participantMap) {
    let participantName = event.isTeamSwap
        ? getParticipantName(event.participants, participantMap.swappedDefaultIndex, participantMap.swappedRole)
        : getParticipantName(event.participants, participantMap.defaultIndex, participantMap.role);
    let participantScore = event.isTeamSwap
        ? event.score ? event.score[participantMap.swappedScore] : "-"
        : event.score ? event.score[participantMap.score] : "-";
    return {
        name: participantName,
        score: participantScore
    };
}
//# sourceMappingURL=GetParticipantData.js.map